// (c) chaehongee. Confidential and proprietary.

import { http, buildApiUrl } from './http'
import type {
    SavedNodeResponse,
    SavedNodesListResponse,
    SavedNodeCheckResponse,
} from 'models-ts/saved-node'

export async function saveNode(nodeId: string): Promise<SavedNodeResponse> {
    return http<SavedNodeResponse>(buildApiUrl('/saved-nodes/'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ node_id: nodeId }),
    })
}

export async function unsaveNode(nodeId: string): Promise<void> {
    await http<void>(buildApiUrl(`/saved-nodes/${encodeURIComponent(nodeId)}`), {
        method: 'DELETE',
    })
}

export async function listSavedNodes(): Promise<SavedNodesListResponse> {
    return http<SavedNodesListResponse>(buildApiUrl('/saved-nodes/'), {
        method: 'GET',
    })
}

export async function checkSavedNodes(nodeIds: string[]): Promise<SavedNodeCheckResponse> {
    const ids = nodeIds.join(',')
    return http<SavedNodeCheckResponse>(buildApiUrl(`/saved-nodes/check?node_ids=${encodeURIComponent(ids)}`), {
        method: 'GET',
    })
}
